// extracted by mini-css-extract-plugin
export default {"inputSelectStyle":"styles_inputSelectStyle__xKTnC","notice":"styles_notice__9jodj"};